import { withSvgIcon } from './withSvgIcon';

export const AddUser = withSvgIcon(
  <>
    <path d="M6 14V22" stroke="currentColor" strokeWidth="2" />
    <path d="M2 18H10" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="7" r="3" stroke="currentColor" strokeWidth="2" />
    <path
      d="M9 14.3736C9.79042 14.1307 10.6299 14 11.5 14C14.3723 14 17.1225 15.4246 18.7661 17.6058C19.5757 18.6802 18.6385 20 17.2932 20H11"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
